import useRequest from "~/hooks/use-request";

export interface ISlide {
  imageUrl: string;
  linkUrl?: string;
  linkTarget?: string;
}

const SlidesAPI = {
  load(): Promise<ISlide[]> {
    const { request } = useRequest();

    const formatSlide = (data: IResponseSlide) => ({
      imageUrl: data.image_url,
      linkUrl: data.link,
      linkTarget: data.target,
      // description: data.text,
    });

    return request
      .get<IResponseSlide[]>("/api/resources/slider")
      .then(response => response.map(formatSlide));
  },
};

export default SlidesAPI;
